import { getEnvVariables } from "../../env";

const env = getEnvVariables();

export const MODEL_V3_URL = `${env.API_V3_URL}v3/models`;
